const successColor = '#38bb15'
const warningColor = '#feb52b'
const errorColor = '#ff2e2e'
const darkGray = '#404040'

const flashMessageStyles = {
  Containers: {
    tc: {
      left: '12.5%',
      margin: '0',
      width: '75%'
    }
  },

  NotificationItem: {
    DefaultStyle: {
      border: 'none',
      textAlign: 'center',
    },
    success: {
      border: '2px solid ' + darkGray,
      backgroundColor: 'white',
      color:  successColor
    },
    warning: {
      border: '2px solid ' + darkGray,
      backgroundColor: 'white',
      color:  warningColor
    },
    error: {
      border: '2px solid ' + darkGray,
      backgroundColor: 'white',
      color:  errorColor
    }
  }
}

export default flashMessageStyles
